import { NavLink, Outlet } from 'react-router-dom';

// Unified Home management page. Wraps the three sub-pages (slides,
// cases, news) behind a single sidebar entry with three tabs at the
// top. Ops asked for this shape (2026-08-27) so the section reads as
// "one screen with three tabs" instead of three parallel sidebar links.
// Each child page keeps its own PageHeader so the tab context (title +
// subtitle) stays live per tab.

export default function HomePage() {
  const tab = (to: string, label: string) => (
    <NavLink
      to={to}
      end
      className={({ isActive }) => `home-tab ${isActive ? 'active' : ''}`}
    >
      {label}
    </NavLink>
  );

  return (
    <>
      <div className="home-tabs" role="tablist" aria-label="أقسام الرئيسية">
        {tab('/home/slides', 'الصور (Carousel)')}
        {tab('/home/cases', 'الحالات')}
        {tab('/home/news', 'آخر الأخبار')}
      </div>

      <div className="home-tab-panel">
        <Outlet />
      </div>
    </>
  );
}
